export default "__VITE_ASSET___2Q4yz8p__"